module.exports = __webpack_public_path__ + "static/img/decorate-3.c2d345e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/images/decorate-3.png
// module id = 0tSp
// module chunks = 64